import { FC } from "react";
import { useSwappingText } from "./hooks/useSwappingText";
import { FADE_MS } from "./constants";


const TextSwapper: FC<{ sentences: string[]; className?: string }> = ({ sentences, className }) => {
  const { text, visible } = useSwappingText(sentences);

  if (!sentences.length) return null;

  return (
    <div role="status" aria-live="polite" className={className}>
      <span style={{ opacity: visible ? 1 : 0, transition: `opacity ${FADE_MS}ms ease-in-out` }}>{text}</span>
    </div>
  );
};

export default TextSwapper;
